var _g, _path, _path2, _polygon;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgSocketsJ1772(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M33.21,4.62A26.5,26.5,0,0,0,26.66,56.8v2.62a2.23,2.23,0,0,0,.63,1.65,3.76,3.76,0,0,0,2.88,1h6.06a3.79,3.79,0,0,0,2.89-1,2.17,2.17,0,0,0,.62-1.6V56.8A26.5,26.5,0,0,0,33.21,4.62Zm-3,56a2.46,2.46,0,0,1-1.78-.51.88.88,0,0,1-.26-.61V55.63l-.56-.14a25,25,0,1,1,11.26,0l-.56.14V59.5a.86.86,0,0,1-.26.58,2.49,2.49,0,0,1-1.78.51H30.17Z",
    fill: "#4f4e4f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.21,3.73a27.4,27.4,0,0,0-7.45,53.76v1.89a3.21,3.21,0,0,0,.87,2.3A4.62,4.62,0,0,0,30.17,63h6.06a4.61,4.61,0,0,0,3.55-1.28,3.17,3.17,0,0,0,.86-2.21v-2A27.4,27.4,0,0,0,33.21,3.73Zm-3,56A2.07,2.07,0,0,1,29,59.47V54.93l-1.26-.31a24.12,24.12,0,1,1,10.86,0l-1.26.31v4.53s-.24.23-1.13.23Z",
    fill: "#4f4e4f"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.55,34.75a4.09,4.09,0,1,0,4.08,4.09A4.09,4.09,0,0,0,20.55,34.75Zm-.05,6a1.87,1.87,0,1,1,1.87-1.87A1.87,1.87,0,0,1,20.5,40.71Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.05,29.91a5.78,5.78,0,1,0-5.77-5.78A5.78,5.78,0,0,0,42.05,29.91Zm0-8.81a3,3,0,1,1-3,3A3,3,0,0,1,42.05,21.1Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.58,30.15a6,6,0,1,0-6-6A6,6,0,0,0,24.58,30.15Zm0-9a3,3,0,1,1-3,3A3,3,0,0,1,24.58,21.1Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.58,39.59a5.78,5.78,0,1,0,5.77,5.78A5.78,5.78,0,0,0,33.58,39.59Zm0,8.82a3,3,0,1,1,3-3A3,3,0,0,1,33.58,48.41Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.85,34.75a4.09,4.09,0,1,0,4.09,4.09A4.08,4.08,0,0,0,45.85,34.75Zm-.05,6.06a2,2,0,1,1,2-2A2,2,0,0,1,45.8,40.81Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5,37a1.87,1.87,0,1,0,1.87,1.87A1.86,1.86,0,0,0,20.5,37Z",
    fill: "#4f4e4f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8,36.86a2,2,0,1,0,2,2,2,2,0,0,0-2-2Z",
    fill: "#4f4e4f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2,10.93A20.7,20.7,0,1,0,53.89,31.62,20.69,20.69,0,0,0,33.2,10.93Zm8.85,7.43a5.78,5.78,0,1,1-5.77,5.77A5.77,5.77,0,0,1,42.05,18.36Zm-17.47-.24a6,6,0,1,1-6,6A6,6,0,0,1,24.58,18.12Zm-4,24.8a4.09,4.09,0,1,1,4.08-4.08A4.09,4.09,0,0,1,20.55,42.92Zm13,8.23a5.78,5.78,0,1,1,5.77-5.78A5.78,5.78,0,0,1,33.58,51.15Zm12.27-8.23a4.09,4.09,0,1,1,4.09-4.08A4.08,4.08,0,0,1,45.85,42.92Z",
    fill: "#4f4e4f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.58,42.33a3,3,0,1,0,3,3,3,3,0,0,0-3-3Z",
    fill: "#4f4e4f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.58,21.1a3,3,0,1,0,3,3,3,3,0,0,0-3-3Z",
    fill: "#4f4e4f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.05,21.1a3,3,0,1,0,3,3,3,3,0,0,0-3-3Z",
    fill: "#4f4e4f"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.64,2.52a1,1,0,0,0-.87.57L21.33,6.41l2.6,1.64,1.88-4.33L24.15,2.67a1,1,0,0,0-.51-.15Z",
    fill: "#4f4e4f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.64,2.52a.94.94,0,0,0-.5.15L40.47,3.72l1.88,4.33L45,6.41,43.52,3.09a1,1,0,0,0-.88-.57Z",
    fill: "#4f4e4f"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "41.13 3.72 25.16 3.72 25.16 5.06 41.13 5.06 41.13 3.72 41.13 3.72",
    fill: "#4f4e4f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSocketsJ1772);
export default __webpack_public_path__ + "static/media/img_sockets_j1772.0ea7ab1b0b9270a983b06a14ec29cd0f.svg";
export { ForwardRef as ReactComponent };